import React, { useState } from "react";
import { StoreIndividual } from "./StoreIndividual.jsx";
import { StorePacks } from "./StorePacks.jsx";
import { twMerge } from "tailwind-merge";

export const Store = () => {
  const [type, set_type] = useState("individual"); // "individual" | "packs"

  return (
    <div className="space-y-6 sm:space-y-8">
      {/* Tab Selection */}
      <div className="flex justify-center">
        <div className="flex p-1 rounded-full bg-r3dark/20 border border-r3lig/30 backdrop-blur-md">
          {[
            { key: "individual", label: "Individual Skins" },
            { key: "packs", label: "Skin Packs" },
          ].map((tabItem) => (
            <button
              key={tabItem.key}
              onClick={() => set_type(tabItem.key)}
              className={twMerge(
                "px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-full font-digi font-semibold text-xs sm:text-sm md:text-base transition-all duration-300",
                type === tabItem.key
                  ? "bg-gradient-to-r from-r3reg to-r3dark text-white shadow-lg"
                  : "text-gray-300 hover:text-white hover:bg-r3lig/20",
              )}
            >
              {tabItem.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      {type === "individual" && <StoreIndividual />}
      {type === "packs" && <StorePacks />}
    </div>
  );
};

